var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signer-roles-container" },
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "e-sign-package.messages.eachTemplateRequiresSignerTypes"
                    )
                  ) +
                  "\n        "
              ),
              _c("br"),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("e-sign-package.messages.youCanBeginUsingFieldBelow")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.signerRolesWithIndexes.length
        ? _c("v-client-table", {
            ref: "table",
            staticClass: "vue-custom-table no-pagination",
            attrs: {
              data: _vm.signerRolesWithIndexes,
              columns: _vm.table.columns,
              options: _vm.table.options,
              name: "signerRolesTable",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "signerType",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [_vm._v("\n        " + _vm._s(row.name) + "\n      ")]
                      ),
                    ]
                  },
                },
                {
                  key: "actions",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        { staticClass: "request-trash ml-4" },
                        [
                          _c("inline-prompt", {
                            staticStyle: { "font-size": "0.8rem" },
                            attrs: {
                              placement: "left",
                              "action-type": "delete",
                            },
                            on: {
                              accept: function ($event) {
                                return _vm.handleDeleteRole(row.index)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3087017649
            ),
          })
        : _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/complete-application.png"),
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "e-sign-package.messages.noSignerTypesOnTemplate"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("material-input", {
                attrs: {
                  "on-type": true,
                  optional: true,
                  label: _vm.$t("e-sign-package.newSignerType"),
                },
                on: { enter: _vm.handleAddRole },
                model: {
                  value: _vm.roleToAdd,
                  callback: function ($$v) {
                    _vm.roleToAdd = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "roleToAdd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "3" } }, [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary ml-4",
                attrs: { type: "button", disabled: !_vm.roleToAddValid },
                on: { click: _vm.handleAddRole },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("global.words.add")) + "\n      "
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }